export const DEMO_MASTER_MEDICATIONS = [
  {
    id: 'sandbox-depakote',
    name: 'Depakote',
    dose: '1000',
    unit: 'mg',
    isArchived: false,
    schedules: [
      {
        id: 'sandbox-depakote-morning',
        time: '08:00',
        dose: '1000',
        unit: 'mg',
      },
    ],
  },
];

export const getMedicationContextLabel = (medication = {}) => {
  const schedule = medication.schedules?.[0] || {};
  const dose = [medication.dose, medication.unit].filter(Boolean).join('');
  return [medication.name, dose, schedule.time ? `@ ${schedule.time}` : '']
    .filter(Boolean)
    .join(' ');
};
